import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { handleWhatsAppClick } from '@/lib/whatsapp.js';
import EditableField from './EditableField.jsx';
import WhatsAppIcon from './WhatsAppIcon.jsx';
import { Checkbox } from "@/components/ui/checkbox";

const ProductCard = ({ section, fieldPrefix, id, title, badge, image, altText, margem, rotatividade, beneficio, exemplo, ctaText, delay = 0, isSelected, onToggleCompare }) => {
  
  const getTrackingId = (productTitle) => {
    const normalized = (productTitle || '').toLowerCase();
    if (normalized.includes('francês')) return 'btn-amostra-pao-frances';
    if (normalized.includes('queijo')) return 'btn-amostra-pao-queijo';
    if (normalized.includes('doces')) return 'btn-amostra-doces-finos';
    return `btn-amostra-${normalized.replace(/[^a-z0-9]+/g, '-')}`;
  };

  const trackingId = getTrackingId(title);

  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }} 
      whileInView={{ opacity: 1, y: 0 }} 
      viewport={{ once: true }} 
      transition={{ delay, duration: 0.5 }}
      className={`bg-white rounded-2xl shadow-md overflow-hidden h-full flex flex-col group transition-all duration-300 w-full max-w-full border-2 ${isSelected ? 'border-primary ring-4 ring-primary/20' : 'border-transparent hover:shadow-xl hover:-translate-y-1'}`}
    >
      <div className="relative overflow-hidden bg-muted flex-shrink-0 w-full">
        <img 
          src={image} 
          alt={altText || title} 
          className="w-full h-48 sm:h-56 object-cover rounded-t-2xl group-hover:scale-105 transition-transform duration-700" 
          loading="lazy" 
        />
        <div className="absolute top-4 left-4 bg-primary text-primary-foreground text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider shadow-md max-w-[calc(100%-2rem)] break-words text-center">
          <EditableField section={section} field={`${fieldPrefix}.badge`} value={badge} />
        </div>
        
        {onToggleCompare && (
          <div className="absolute top-4 right-4 bg-white/95 backdrop-blur-sm p-2 rounded-lg shadow-sm flex items-center gap-2 cursor-pointer z-10 max-w-[calc(100%-2rem)]" onClick={() => onToggleCompare(id)}>
            <Checkbox id={`compare-${id}`} checked={isSelected} onCheckedChange={() => onToggleCompare(id)} className="flex-shrink-0" />
            <label htmlFor={`compare-${id}`} className="text-xs font-bold cursor-pointer select-none break-words text-slate-900">Comparar</label>
          </div>
        )}
      </div>
      
      <div className="p-5 sm:p-6 flex-1 flex flex-col w-full">
        <EditableField section={section} field={`${fieldPrefix}.title`} value={title} as="h3" className="font-heading text-xl sm:text-2xl font-bold mb-4 block text-foreground leading-tight break-words w-full" />
        
        <div className="space-y-3 mb-6 flex-1 w-full">
          <div className="flex justify-between border-b border-border pb-2 text-sm items-center gap-2 flex-wrap sm:flex-nowrap w-full">
            <span className="text-muted-foreground flex-shrink-0">Margem de Lucro:</span>
            <EditableField section={section} field={`${fieldPrefix}.margem`} value={margem} className="font-bold text-primary text-right text-base break-words flex-1 sm:flex-none" />
          </div>
          <div className="flex justify-between border-b border-border pb-2 text-sm items-center gap-2 flex-wrap sm:flex-nowrap w-full">
            <span className="text-muted-foreground flex-shrink-0">Rotatividade:</span>
            <EditableField section={section} field={`${fieldPrefix}.rotatividade`} value={rotatividade} className="font-bold text-foreground text-right break-words flex-1 sm:flex-none" />
          </div>
          <div className="bg-primary/5 border border-primary/10 text-foreground p-4 rounded-xl text-sm font-medium mt-4 flex flex-col w-full">
            <span className="font-bold text-[11px] uppercase text-primary mb-1 tracking-wide">Benefício Real:</span>
            <EditableField section={section} field={`${fieldPrefix}.beneficio`} value={beneficio} multiline className="break-words leading-relaxed" />
          </div>
        </div>
        
        <EditableField section={section} field={`${fieldPrefix}.exemplo`} value={exemplo} as="p" className="text-sm italic text-muted-foreground mb-6 block break-words w-full" />
        
        <div className="mt-auto flex flex-col gap-2 pt-2 w-full">
          <button 
            id={trackingId}
            data-gtm="whatsapp"
            data-gtm-event="click_whatsapp"
            data-gtm-category="lead"
            data-gtm-action="click"
            onClick={() => handleWhatsAppClick(`Olá Hiperpan! Tenho interesse no ${title} e gostaria de solicitar um orçamento.`)} 
            className="gtm-whatsapp cta-button cta-button-full btn-primary-cro w-full py-3 px-4"
          >
            <WhatsAppIcon className="cta-icon flex-shrink-0" />
            <span className="whitespace-normal text-center break-words leading-tight flex-1">
              <EditableField section={section} field={`${fieldPrefix}.ctaText`} value={ctaText || 'SOLICITAR ORÇAMENTO'} />
            </span>
            <ArrowRight className="cta-arrow flex-shrink-0" />
          </button>
          <p className="text-[10px] text-muted-foreground text-center mt-2 break-words px-2 w-full">
            *Exclusivo para CNPJ do segmento
          </p>
        </div>
      </div>
    </motion.div>
  );
};

export default ProductCard;